import React from 'react';
import { useTranslation } from "react-i18next";
const Languageoption = (props) => {
    const { t } = useTranslation();
    return (
        <div >
            <select className="form-select" onChange={props.onChange} >
                <option value={'en'} selected={localStorage.getItem('selectedLanguage')==='en'?true:false}>English</option>
                <option value={'odi'} selected={localStorage.getItem('selectedLanguage')==='odi'?true:false}>{t("Odia")}</option>
            </select>
        </div>
    )
}
export default Languageoption;


